module.exports = __webpack_public_path__ + "img/img83.5851ff42.png";